import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchAddressById } from '../query-api'

export const useFetchShippingAddress = (addressId?: string | null) => {
  const { data, isLoading, ...rest } = useQuery(
    [QueryKeys.Addresses, addressId],
    () => fetchAddressById(addressId as string),
    {
      enabled: !!addressId,
      keepPreviousData: true,
    },
  )

  return {
    shippingAddress: data?.address,
    isLoading,
    ...rest,
  }
}
